import { BehaviorSubject, firstValueFrom, Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";
import {SubscriptionBase} from "@core/base/subscription-base";
import {ISubscription} from "@core/base/subscription-base.types";
import { environment } from "@env";
import {logger} from "@services/logger/logger.service";

const subscriptionDefault: ISubscription = {
    success: false,
    message: '',
    can_trial_add: false,
    subscription_id: '',
    title: '',
    is_trial: false,
    is_personal: false,
    owner_name: '',
    from_date: '',
    till_date: '',
    users_left: 0,
    tokens_left: 0,
    token_packs: 0,
    is_active: false,
    is_current_user_included: false,

}


export class OfficeSubscription implements SubscriptionBase {
    private subscription: BehaviorSubject<ISubscription> = new BehaviorSubject<ISubscription>(subscriptionDefault);
    private sessionID = '';

    constructor(private http: HttpClient) {
    }

    public openSubscriptionDocs(): void {
        try {
            const sessionID = this.sessionID;
            const url = environment.office_api_host + `/subscription/require?session_id=${sessionID}`;
            const windowOptions = {
                width: 50,  // percentage of current display
                height: 50, // percentage of current display
                info_title: 'R2 Copilot: to continue,<br/>please complete your subscription.<br/><br/><br/>',
                close_title: 'Cancel'
            }
            Office.context.ui.displayDialogAsync(url, windowOptions, (res) => {
                logger.log(res);
            })
        } catch (e) {
            logger.error(e);
        }
    }

    public getSubscription(): ISubscription {
        return this.subscription.getValue();
    }

    public $getSubscription(): Observable<ISubscription> {
        return this.subscription.asObservable();
    }

    public async fetchSubscription(sessionID: string): Promise<ISubscription> {
        this.sessionID = sessionID
        const url = `${environment.office_api_host}/api/check-subscription/${sessionID}`
        const data = await firstValueFrom<ISubscription>(
            this.http.post<ISubscription>(url, {})
        );
        this.subscription.next(data);
        return data;
    }

    public async fetchSubscribeTrial(sessionID: string): Promise<void> {
        this.sessionID = sessionID
        const url = `${environment.office_api_host}/api/subscribe-trial/${sessionID}?result=json`
        const data = await firstValueFrom<ISubscription>(
            this.http.post<ISubscription>(url, {})
        )

        this.subscription.next(data);
    }
}
